import storage from 'store'
import store from '@/store'
export default () => {
    // 清除token
    storage.remove('auth');
    let href = window.location.href;
    // 去除过多的unified
    href = href.split('unified=');
    href = href[0];
    window.location.href = store.state.meetingInfo.domain+"/unified/login?return_url=" + encodeURIComponent(href);
}